import { DefaultPaymentTypeCode } from 'enums';

export type MonitoringAmountRange = {
  min: number;
  max?: number;
};

export enum MonitoringAlertLevel {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export type MonitoringDataItem = {
  label: string;
  minAmount: number;
  maxAmount: number;
  paymentTypeCode: DefaultPaymentTypeCode;
  paymentType: DefaultPaymentTypeCode;
  alertLevel: MonitoringAlertLevel;
  ordersCount: number;
};

export type BankAggregatedMonitoringItem = MonitoringDataItem & {
  bankId: string;
};

export type BaseMonitoringDataRow = Record<
  DefaultPaymentTypeCode,
  { label: string; alertLevel: MonitoringAlertLevel }
>;

export type RangeMonitoringDataRow<T extends MonitoringDataItem> =
  BaseMonitoringDataRow & {
    minAmount: T['minAmount'];
  };

export type BankMonitoringDataRow<T extends BankAggregatedMonitoringItem> =
  BaseMonitoringDataRow & {
    bankId: T['bankId'];
  };
